import { Container } from "@mui/material";
import CustomTable from "../../components/CustomTable";
import SectionTitle from "../../components/SectionTitle";
import { DEV_ROADMAP } from "../../constants";

const DevRoadmap = () => {
  return (
    <section id="dev-roadmap">
      <Container
        sx={{
          whiteSpace: "pre-wrap",
        }}
      >
        <SectionTitle title="DEVELOPMENT"></SectionTitle>
        <SectionTitle title="ROADMAP"></SectionTitle>
        <CustomTable rows={DEV_ROADMAP} />
      </Container>
    </section>
  );
};

export default DevRoadmap;
